import React, { FC, PropsWithChildren } from "react";

export type ModalProps = {
  show: boolean;
  onClose?: () => void;
  label: string;
  id?: string;
  headerShow?: boolean;
  className?: string;
};

export const Modal: FC<PropsWithChildren<ModalProps>> = ({
  label = "Modal",
  id,
  children,
  show = true,
  onClose,
  className,
}) => {
  if (!show) {
    return null;
  }
  return (
    <div className="modal-backdrop">
      <div
        className="modal fade show"
        id={id}
        data-backdrop="static"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="newContactModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className={`modal-content ${className}`}>
            <div className="modal-header">
              <h5 className="modal-title" id={`${id}-Label`}>
                {label}
              </h5>
              <button
                type="button"
                onClick={onClose}
                className="btn btn-smclose"
                data-dismiss="modal"
                aria-label="Close"
              >
                x
              </button>
            </div>
            <div className="modal-body">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
